var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "max-w-xl m-auto" },
    [
      _c("terminals-search", {
        attrs: { loading: _vm.loading },
        on: { searchClick: _vm.handleSearchBySerialNumber },
      }),
      _c("terminal-list", {
        attrs: {
          items: _vm.items,
          loading: _vm.loading,
          pagination: _vm.pagination,
        },
        on: { onPrevious: _vm.onPrevious, onNext: _vm.onNext },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }